export default __webpack_public_path__ + "static/media/invoiceMobile.1c3e142c.jpg";